import { Component } from '@angular/core';
import { Route, Router } from '@angular/router';
import { ComponentBase } from 't4core';
import { DialogService } from '../../../t4common';

@Component({
    selector: 'nav-menu',
    templateUrl: './navmenu.component.html',
    styleUrls: ['./navmenu.component.css']
})  
export class NavMenuComponent extends ComponentBase {
    public isExpanded: Boolean = false;

    public items = new Array<any>();

    constructor(public router: Router) {
        super();

        this.rebuildMenu();
    }

    private rebuildMenu() {
        
        this.items = new Array<any>();
        for (var i = 0; i < this.router.config.length; i++) {
            if (this.router.config[i].data == null || this.router.config[i].data!["hidden"]) continue;

          if (this.router.config[i].data!["roles"] != null) {
            var brands = this.router.config[i].data!["brands"] != null && this.router.config[i].data!["brands"].length > 0 ? this.router.config[i].data!["brands"] : null;
            var skipbrands = this.router.config[i].data!["skipbrands"] != null && this.router.config[i].data!["skipbrands"].length > 0 ? this.router.config[i].data!["skipbrands"] : null;
            
            if (!this.Settings.isInAny(this.router.config[i].data!["roles"], false, brands, skipbrands) || !(!this.router.config[i].data!["requireOneWay"] || this.Settings.clientSettings.IsOneWay)) continue;
            if (!this.Settings.isInAny(this.router.config[i].data!["roles"], false, brands, skipbrands) || !(!this.router.config[i].data!["requireCampaignEnabled"] || (this.Settings.isInAny(['BusinessManager']) && !this.Settings.isInAny(['Admin', 'GroupManager', 'LocationManager']) && this.Settings.clientSettings.PartnerCampaignEnabled) || (this.Settings.isInAny(['Admin', 'GroupManager', 'LocationManager'])))) continue;
          }

          if (this.router.config[i].data!["rights"] != null) {
            if (!this.Settings.may(this.router.config[i].data!["rights"])) continue;
          }

          if (this.router.config[i].data!["experimental"] === true) {
            if (!this.Settings.isInAny(['Admin'], true)) continue;
          }


          var tmp = { index: this.router.config[i].data!["index"], path: this.router.config[i].path, icon: this.router.config[i].data["icon"], title: this.router.config[i].data["title"], children: [] };


          for (var j = 0; j < this.router.config[i].children!.length; j++) {
            if (this.router.config[i].children![j].data == null || this.router.config[i].children![j].data!["hidden"]) continue;
            var brands = this.router.config[i].children![j].data!["brands"] != null && this.router.config[i].children![j].data!["brands"].length > 0 ? this.router.config[i].children![j].data!["brands"] : null;
            var skipbrands = this.router.config[i].children![j].data!["skipbrands"] != null && this.router.config[i].children![j].data!["skipbrands"].length > 0 ? this.router.config[i].children![j].data!["skipbrands"] : null;
            
            if ((this.router.config[i].children![j].data!["roles"] != null && !this.Settings.isInAny(this.router.config[i].children![j].data!["roles"], false, brands, skipbrands)) || !(!this.router.config[i].children![j].data!["requireOneWay"] || this.Settings.clientSettings.IsOneWay)) continue;
            if ((this.router.config[i].children![j].data!["roles"] != null && !this.Settings.isInAny(this.router.config[i].children![j].data!["roles"], false, brands, skipbrands)) || !(!this.router.config[i].children![j].data!["requireCampaignEnabled"] || (this.Settings.isInAny(['BusinessManager']) && !this.Settings.isInAny(['Admin', 'GroupManager', 'LocationManager']) && this.Settings.clientSettings.PartnerCampaignEnabled) || (this.Settings.isInAny(['Admin', 'GroupManager', 'LocationManager'])))) continue;
            if (this.router.config[i].children![j].data!["requireLanguage"] && this.router.config[i].children![j].data!["requireLanguage"].indexOf(this.Settings.clientSettings.Language) < 0) continue;

            tmp.children.push(
              {
                title: this.router.config[i].children![j].data!["title"],
                path: "/" + this.router.config[i].path + "/" + this.router.config[i].children![j].path,
                icon: this.router.config[i].children![j].data!["icon"],
                uri: this.router.config[i].children![j].data!["uri"],
                target: this.router.config[i].children![j].data!["target"],
              });
          }

          this.items.push(tmp);
      }

      this.items.sort((a, b) => {
        if (a.index < b.index) return -1;
        if (a.index == b.index) return 0;
        else return 1;
      })
    }

    protected authenticationChanged() {
        this.rebuildMenu();
  }
}
